<div class="gallery-panel">
    <div class="gallery-header">
        <h3 class="panel-title">SVG Gallery</h3>
        <button class="upload-button" (click)="triggerUpload()" title="Upload SVG">Upload SVG</button>
        @if (currentPath().length > 0) {
            <button class="breadcrumb-back" (click)="goBack()" title="Back">
                ← Back
            </button>
        }
    </div>

    <input
        #svgUploadInput
        type="file"
        accept="image/svg+xml,.svg"
        style="display: none"
        (change)="onSvgSelected($event)"/>

    <!-- Breadcrumb Navigation -->
    @if (currentPath().length > 0) {
        <div class="breadcrumb">
            <button class="breadcrumb-item" (click)="navigateToRoot()">Root</button>
            @for (item of currentPath(); track item.id) {
                <span class="breadcrumb-separator">/</span>
                <span class="breadcrumb-item">{{ item.name }}</span>
            }
        </div>
    }

    <!-- Main Gallery Content -->
    <div class="gallery-content">
        @if (isVisitingCard()) {
            <div class="gallery-section samples-section">
                <h4 class="section-title">Samples</h4>
                <div class="samples-grid">
                    <button class="sample-tile classic" type="button" (click)="addVisitingCardAsset('front')">
                        <div class="sample-preview">
                            <div class="preview-card classic">
                                <img class="preview-image" src="/assets/visiting-card-sample/vc-ai-sample-front.svg" alt="Visiting card AI front" />
                            </div>
                        </div>
                        <div class="sample-label">AI Front</div>
                    </button>

                    <button class="sample-tile classic" type="button" (click)="addVisitingCardAsset('back')">
                        <div class="sample-preview">
                            <div class="preview-card classic">
                                <img class="preview-image" src="/assets/visiting-card-sample/vc-ai-sample-back.svg" alt="Visiting card AI back" />
                            </div>
                        </div>
                        <div class="sample-label">AI Back</div>
                    </button>

                    <button class="sample-tile classic" type="button" (click)="addAssetSvg('/assets/visiting-card-sample/sample_fe.svg')">
                        <div class="sample-preview">
                            <div class="preview-card classic">
                                <img class="preview-image" src="/assets/visiting-card-sample/sample_fe.svg" alt="Visiting card original front" />
                            </div>
                        </div>
                        <div class="sample-label">Original Front</div>
                    </button>

                    <button class="sample-tile classic" type="button" (click)="addAssetSvg('/assets/visiting-card-sample/sample_be.svg')">
                        <div class="sample-preview">
                            <div class="preview-card classic">
                                <img class="preview-image" src="/assets/visiting-card-sample/sample_be.svg" alt="Visiting card original back" />
                            </div>
                        </div>
                        <div class="sample-label">Original Back</div>
                    </button>
                </div>
            </div>
        }
        @if (isEnvelope()) {
            <div class="gallery-section samples-section">
                <h4 class="section-title">Envelope Samples</h4>
                <div class="samples-grid single">
                    <button class="sample-tile" type="button" (click)="addAssetSvg('/assets/envelope-sample/envelope.svg')">
                        <div class="sample-preview">
                            <div class="preview-card">
                                <img class="preview-image" src="/assets/envelope-sample/envelope.svg" alt="Envelope sample" />
                            </div>
                        </div>
                        <div class="sample-label">Envelope</div>
                    </button>
                </div>
            </div>
        }
        @if (isLetterhead()) {
            <div class="gallery-section samples-section">
                <h4 class="section-title">Letterhead Samples</h4>
                <div class="samples-grid three">
                    <button class="sample-tile" type="button" (click)="addAssetSvg('/assets/letterhead-sample/Letterhead.svg')">
                        <div class="sample-preview">
                            <div class="preview-card">
                                <img class="preview-image" src="/assets/letterhead-sample/Letterhead.svg" alt="Letterhead sample 1" />
                            </div>
                        </div>
                        <div class="sample-label">Letterhead 1</div>
                    </button>
                    <button class="sample-tile" type="button" (click)="addAssetSvg('/assets/letterhead-sample/Letterhead_2.svg')">
                        <div class="sample-preview">
                            <div class="preview-card">
                                <img class="preview-image" src="/assets/letterhead-sample/Letterhead_2.svg" alt="Letterhead sample 2" />
                            </div>
                        </div>
                        <div class="sample-label">Letterhead 2</div>
                    </button>
                    <button class="sample-tile" type="button" (click)="addAssetSvg('/assets/letterhead-sample/Letterhead_3.svg')">
                        <div class="sample-preview">
                            <div class="preview-card">
                                <img class="preview-image" src="/assets/letterhead-sample/Letterhead_3.svg" alt="Letterhead sample 3" />
                            </div>
                        </div>
                        <div class="sample-label">Letterhead 3</div>
                    </button>
                </div>
            </div>
        }
        <!-- Folders -->
        @if (currentFolders().length > 0) {
            <div class="gallery-section">
                <h4 class="section-title">Folders</h4>
                <div class="gallery-grid folders-grid">
                    @for (folder of currentFolders(); track folder.id) {
                        <div
                            class="folder-item"
                            (click)="navigateToFolder(folder)">
                            <div class="folder-icon">{{ folder.icon }}</div>
                            <div class="folder-name">{{ folder.name }}</div>
                            <div class="folder-count">{{ folder.items.length + (folder.subfolders?.length || 0) }} items</div>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Items in Current Location -->
        @if (currentItems().length > 0) {
            <div class="gallery-section">
                <h4 class="section-title">Files</h4>
                <div class="gallery-grid items-grid">
                    @for (item of currentItems(); track item.id) {
                        <div
                            class="gallery-item"
                            draggable="true"
                            (dragstart)="onDragStart($event, item)"
                            (click)="addItemToCanvas(item)">
                            <div class="preview">
                                <img [src]="item.url" [alt]="item.name" draggable="false"/>
                            </div>
                            <div class="label">{{ item.name }}</div>
                            @if (item.category) {
                                <div class="category">{{ item.category }}</div>
                            }
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Empty State -->
        @if (currentFolders().length === 0 && currentItems().length === 0) {
            <div class="empty-gallery">
                <div class="empty-icon">📁</div>
                <p>No items found</p>
            </div>
        }
    </div>
</div>
